import { render, staticRenderFns } from "./GroupModeForm.vue?vue&type=template&id=1c56f645&scoped=true&"
import script from "./GroupModeForm.vue?vue&type=script&lang=ts&"
export * from "./GroupModeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c56f645",
  null
  
)

export default component.exports